<script lang="ts" setup>
import { ref, reactive } from 'vue'
import { z } from 'zod'

const toast = useToast()

const magicLinkSchema = z.object({
  email: z
  .string({ required_error: 'Požadované' })
  .email('Neplatný email'),
})

const state = reactive({
  email: undefined,
})

const loading = ref(false)

async function onSubmit(event) {
  try {
    loading.value = true
    await $fetch('/api/auth/login-with-otp', {
      method: 'POST',
      body: event.data,
    })
    toast.add({
      id: `otp_sent`,
      title: `Kód byl na email úspěšně zaslán.`,
      icon: 'i-heroicons-check-circle',
      timeout: 5000,
      color: 'green',
    })
    navigateTo(
      `/auth/verify-otp?email=${encodeURIComponent(state.email)}&type=LOGIN`
    )
  } catch (error) {
    loading.value = false
    toast.add({
      id: `otp_sent_error`,
      title: `Odeslání kódu na email nebylo úspěšné.`,
      icon: 'i-heroicons-x-circle',
      timeout: 5000,
      color: 'red',
    })
    // toast.error(error.data.statusMessage)
  }
}
</script>

<template>
  <UForm
    :schema="magicLinkSchema"
    :state="state"
    class="max-w-sm space-y-4"
    @submit="onSubmit"
  >
    <UFormGroup name="email" size="lg" required>
      <template #label>
        <UIcon
          name="heroicons:envelope"
          class="-mb-1 h-5 w-5 text-gray-400"
        />
        <span class="mx-1">Email</span>
      </template>
      <UInput v-model="state.email" class="mt-1"/>
    </UFormGroup>
    <UButton
      :loading="loading"
      color="orange"
      type="submit"
      :disabled="loading"
      size="lg"
      block
    >
      Poslat odkaz
    </UButton>
  </UForm>
</template>
